import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Employee } from '../interfaces/timesheet';

interface TeamState {
    teamsBySite: {
        [siteMatricule: string]: Employee[]; // Teams associated with SiteDetails using `matricule` as key
    };
    loading: boolean;
    error: string | null;
}

const initialState: TeamState = {
    teamsBySite: {}, // Teams organized by SiteDetail matricule
    loading: false,
    error: null
};

const teamSlice = createSlice({
    name: 'team',
    initialState,
    reducers: {
        setTeamForSite: (state, action: PayloadAction<{ siteMatricule: number; team: Employee[] }>) => {
            const { siteMatricule, team } = action.payload;
            state.teamsBySite[siteMatricule] = team; // Store the team by Site matricule
        },
        addTeamMemberToSite: (state, action: PayloadAction<{ siteMatricule: string; employee: Employee }>) => {
            const { siteMatricule, employee } = action.payload;
            if (!state.teamsBySite[siteMatricule]) {
                state.teamsBySite[siteMatricule] = [];
            }
            // Avoid duplicate team members
            if (!state.teamsBySite[siteMatricule].some(member => member.matricule === employee.matricule)) {
                state.teamsBySite[siteMatricule].push(employee);
            }
        },
        removeTeamMemberFromSite: (state, action: PayloadAction<{ siteMatricule: number; matricule: number }>) => {
            const { siteMatricule, matricule } = action.payload;
            state.teamsBySite[siteMatricule] = state.teamsBySite[siteMatricule]?.filter(member => member.matricule !== matricule) || [];
        },
        clearTeamForSite: (state, action: PayloadAction<string>) => {
            const siteMatricule = action.payload;
            state.teamsBySite[siteMatricule] = [];
        },
        reset: (state) => {
            state.teamsBySite = {};
            state.loading = false;
            state.error = null;
        }
    }
});

export const { setTeamForSite, addTeamMemberToSite, removeTeamMemberFromSite, clearTeamForSite, reset } = teamSlice.actions;

export default teamSlice.reducer;
